import { onUnmounted, watch } from 'vue';

export default (props: { show: boolean }, handler: () => void) => {
  const showPropWatchHandler = watch(
    () => props.show,
    () => {
      if (props.show) handler();
    },
  );

  onUnmounted(() => {
    showPropWatchHandler();
  });
};
